<template>
  <div>
    <section class="modal-card-body has-text-left">
      <step-tracker></step-tracker>

      <h2 class="step-heading" v-t="`${langRoot}.security.title`" />

      <div class="field question" v-for="(question, index) in questions" :key="question.id">
        <!-- Question Text -->
        <label
          class="label question__label"
          :for="`question-${question.id}`"
        >{{ index + 1 }}. {{ $t(`accountRecoveryQuestion.${question.id}`) }}</label>

        <!-- Answer -->
        <div class="control">
          <input
            v-focus="index === 0"
            :id="`question-${question.id}`"
            v-model="answers[question.id]"
            type="text"
            class="input"
            :data-ci="`question-${index}`"
            @change="$trackEvent(pageTag, 'answer_entered', [index + 1])"
            autocomplete="off"
          />
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <div class="level is-block">
        <div class="level-right is-pulled-right">
          <button
            @click="submit"
            class="btn primary"
            :class="{ 'inactive': !isValid }"
            v-t="`${langRoot}.security.submitBtn`"
            data-ci="pr-step2-next-button"
            :disabled="!isValid"
          />
        </div>

        <div class="level-left is-pulled-left">
          <router-link
            class="btn is-ghost"
            :to="{ name: 'passwordreset' }"
            v-t="`${langRoot}.security.cancelBtn`"
          />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty, values } from 'lodash';
import StepTracker from './PasswordStepTracker';
import tracking from '@shared/mixins/tracking';

const name = 'passwordreset-security';
export default {
    name,
    componentName: name,
    mixins: [tracking],
    components: {
        [StepTracker.name]: StepTracker,
    },

    props: {
        langRoot: { type: String, required: true },
    },

    data() {
        return {
            answers: {},
        };
    },

    created() {
        if (isEmpty(this.questions)) {
            this.$router.replace({ name: 'Login' });
        }
    },

    computed: {
        ...mapGetters('passwordreset', ['getRecoveryQuestions']),

        questions() {
            return this.getRecoveryQuestions();
        },

        isValid(){
          return values(this.answers).length === this.questions.length
        }
    },

    methods: {
        ...mapActions('passwordreset', ['setAnswers']),
        submit() {
            this.setAnswers(this.answers).then(() => {
                this.$trackEvent(this.pageTag, 'submit');
                this.$router.replace({ name: 'passwordreset.new' });
            });
        },

        cancel() {
            this.$trackEvent(this.pageTag, 'cancel');
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/PasswordResetSecurity.vue